/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const menu = {
    // 获取菜单
    getmenu (params) {
        return axios.get(`${base.dev}/categories`);
    },
    // 获取顶端菜单
    getTopmenu (query) {
        return axios.get(`${base.dev}/v2/menu/getMenuWeb`,{params:query});
    },
    // 获取目录产品
    getMenuProduits (type) {
        return axios.get(`${base.dev}/categories/${type}/produits`);
    },
    // 获取目录产品
    getMenuVendeurs (type) {
        return axios.get(`${base.dev}/categories/${type}/vendeurs`);
    },

    getLang(query){
        return axios.get(`${base.dev}/pages/v4page`,{params:query});
    }

    // 其他接口…………
}

export default menu;

